const { defineTheme, copy, value } = require('@dbk/theme-utils');

const theme = require('@dbk/ui-theme');

module.exports = defineTheme('dropdown', {
  /**
   * @label Arrow color
   * @editor color
   */
  arrowColor: copy(theme.palettePrimaryInverseText),
  /**
   * @label Arrow color (hover)
   * @editor color
   */
  arrowHoverColor: copy(theme.palettePrimaryInverseText),
  /**
   * @label Focused arrow color
   * @editor color
   */
  arrowFocusColor: copy(theme.palettePrimaryInverseText),
  /**
   * @label Dropdown background color
   * @editor color
   */
  backgroundColor: copy(theme.contentBackground),
  /**
   * @label Disabled stroke color
   * @editor color
   */
  disabledStrokeColor: copy(theme.palettePrimaryTextDisabled),
  /**
   * @label Disabled text color
   * @editor color
   */
  disabledTextColor: copy(theme.palettePrimaryTextDisabled),
  /**
   * @label Disabled text opacity
   * @editor opacity
   */
  disabledTextOpacity: value('opacity', 0.8),
  /**
   * @label Dropdown disabled state background color
   * @editor color
   */
  disabledBackground: copy(theme.palettePrimaryDisabled),
  /**
   * @label Dropdown border size on disabled state
   * @editor width
   */
  disabledBorderSize: value('size', 0, 'px'),
  /**
   * @label Dropdown border color on disabled state
   * @editor color
   */
  disabledBorderColor: copy(theme.palettePrimaryDisabled),
  /**
   * @label Border color (error)
   * @editor color
   */
  borderErrorColor: copy(theme.palettePrimaryError),
  /**
   * @label Border hover color (error)
   * @editor color
   */
  borderErrorHoverColor: copy(theme.palettePrimaryHover),
  /**
   * @label Border color (success)
   * @editor color
   */
  borderSuccessColor: copy(theme.palettePrimarySuccess),
  /**
   * @label Border hover color (success)
   * @editor color
   */
  borderSuccessHoverColor: copy(theme.palettePrimaryHover),
  /**
   * @label Border inverse color (error)
   * @editor color
   */
  inverseBorderErrorColor: copy(theme.palettePrimaryInverseError),
  /**
   * @label Border inverse hover color (error)
   * @editor color
   */
  inverseBorderErrorHoverColor: copy(theme.palettePrimaryHover),
  /**
   * @label Border inverse color (success)
   * @editor color
   */
  inverseBorderSuccessColor: copy(theme.palettePrimaryInverseSuccess),
  /**
   * @label Border inverse hover color (success)
   * @editor color
   */
  inverseBorderSuccessHoverColor: copy(theme.palettePrimaryHover),
  /**
   * @label Dropdown width
   * @editor width
   */
  buttonWidth: value('size', undefined),
  /**
   * @label Dropdown max width
   * @editor width
   */
  buttonMaxWidth: value('size', 180, 'px'),
  /**
   * @label Dropdown min width
   * @editor width
   */
  buttonMinWidth: value('size', 0, 'px'),
  /**
   * @label Number of visible items in option list
   * @editor width
   */
  nrOfShownItemsInList: value('size', 7),
  /**
   * @label Option Item vertical padding (small)
   * @editor padding
   */
  optionVerticalPaddingSmall: value('size', 4, 'px'),
  /**
   * @label Option Item vertical padding (medium)
   * @editor padding
   */
  optionVerticalPaddingMedium: value('size', 4, 'px'),
  /**
   * @label Option Item vertical padding (large)
   * @editor padding
   */
  optionVerticalPaddingLarge: value('size', 4, 'px'),
  /**
   * @label Option Item horizontal padding (small)
   * @editor padding
   */
  optionHorizontalPaddingSmall: value('size', 14, 'px'),
  /**
   * @label Option Item horizontal padding (medium)
   * @editor padding
   */
  optionHorizontalPaddingMedium: value('size', 14, 'px'),
  /**
   * @label Option Item horizontal padding (large)
   * @editor padding
   */
  optionHorizontalPaddingLarge: value('size', 14, 'px'),
  /**
   * @label Dropdown vertical padding (small)
   * @editor padding
   */
  buttonVerticalPaddingSmall: copy(theme.verticalPaddingSmall),
  /**
   * @label Dropdown vertical padding (medium)
   * @editor padding
   */
  buttonVerticalPaddingMedium: copy(theme.verticalPaddingMedium),
  /**
   * @label Dropdown vertical padding (large)
   * @editor padding
   */
  buttonVerticalPaddingLarge: copy(theme.verticalPaddingLarge),
  /**
   * @label Dropdown horizontal padding (small)
   * @editor padding
   */
  buttonHorizontalPaddingSmall: copy(theme.horizontalPaddingSmall),
  /**
   * @label Dropdown horizontal padding (medium)
   * @editor padding
   */
  buttonHorizontalPaddingMedium: copy(theme.horizontalPaddingMedium),
  /**
   * @label Dropdown horizontal padding (large)
   * @editor padding
   */
  buttonHorizontalPaddingLarge: copy(theme.horizontalPaddingLarge),
  /**
   * @label Dropdown horizontal padding native (medium)
   * @editor padding
   */
  buttonHorizontalPaddingNative: copy(theme.horizontalPaddingNative),
  /**
   * @label Hover text color
   * @editor color
   */
  hoverTextColor: copy(theme.palettePrimaryHoverText),
  /**
   * @label Hover text opacity
   * @editor opacity
   */
  hoverTextOpacity: value('opacity', 0.8),
  /**
   * @label Options background color
   * @editor color
   */
  optionsBackgroundColor: copy(theme.palettePrimaryBackground),
  /**
   * @label Option background color
   * @editor color
   */
  optionBackgroundColor: copy(theme.paletteBackgroundTransparent),
  /**
   * @label Option hover color
   * @editor color
   */
  optionHoverColor: copy(theme.palettePrimaryHoverText),
  /**
   * @label Option background color
   * @editor color
   */
  optionHoverBackgroundColor: copy(theme.paletteSecondaryBackground),
  /**
   * @label Option border color
   * @editor color
   */
  optionBorderColor: copy(theme.palettePrimaryShadow),
  /**
   * @label Option border size
   * @editor width
   */
  optionBorderSize: copy(theme.primarySizingBorder),
  /**
   * @label Dropdown options container min width
   * @editor width
   */
  optionMinWidth: value('size', 150, 'px'),
  /**
   * @label list max width.
   * @editor height
   */
  maxWidth: value('size', 225, 'px'),
  /**
   * @label Dropdown tether offset left
   * @editor width
   */
  tetherOffsetLeft: copy(theme.tetherOffsetLeft),
  /**
   * @label Dropdown tether offset top
   * @editor width
   */
  tetherOffsetTop: copy(theme.tetherOffsetTop),
  /**
   * @label Option shadow top position
   * @editor height
   */
  optionBoxShadowTop: value('size', 0, 'px'),
  /**
   * @label Option shadow right position
   * @editor width
   */
  optionBoxShadowRight: value('size', 1, 'px'),
  /**
   * @label Option shadow bottom position
   * @editor height
   */
  optionBoxShadowBottom: value('size', 2, 'px'),
  /**
   * @label Option shadow left position
   * @editor width
   */
  optionBoxShadowLeft: value('size', 0, 'px'),
  /**
   * @label Option container horizontal align position
   * @editor margin
   */
  optionHorizontalAlignSmall: value('size', 12, 'px'),
  /**
   * @label Option container horizontal align position
   * @editor margin
   */
  optionHorizontalAlignMedium: value('size', 14, 'px'),
  /**
   * @label Option container horizontal align position
   * @editor margin
   */
  optionHorizontalAlignLarge: value('size', 16, 'px'),
  /**
   * @label Selected option background color
   * @editor color
   */
  selectedOptionBackgroundColor: copy(theme.paletteSecondaryBackground),
  /**
   * @label Selected option text color
   * @editor color
   */
  selectedOptionTextColor: copy(theme.paletteSecondaryText),
  /**
   * @label Text color
   * @editor color
   */
  textColor: copy(theme.palettePrimaryInverseText),
  /**
   * @label Group text color
   * @editor color
   */
  groupTextColor: copy(theme.palettePrimaryInverseText),
  /**
   * @label Text hover border color
   * @editor color
   */
  textHoverBorderColor: copy(theme.palettePrimaryShadow),
  /**
   * @label Text hover border size
   * @editor width
   */
  textHoverBorderSize: copy(theme.primarySizingBorder),
  /**
   * @label Dropdown border size
   * @editor width
   */
  borderSize: value('size', 0, 'px'),
  /**
   * @label Dropdown Inverse Border Size
   * @editor width
   */
  inverseBorderSize: value('size', 0, 'px'),
  /**
   * @label Dropdown border color
   * @editor color
   */
  borderColor: copy(theme.palettePrimaryStrokeLine),
  /**
   * @label Dropdown Inverse Tether border color
   * @editor color
   */
  inverseTetherBorderColor: copy(theme.palettePrimaryInverseActiveBackground),
  /**
   * @label inverse tether box shadow h offset width
   * @editor width
   */
  inverseTetherBoxshadowHOffsetWidth: value('size', 0, 'px'),
  /**
   * @label inverse tether box shadow v offset width when the list is below the target element
   * @editor width
   */
  inverseTetherBoxshadowVOffsetWidthBelow: value('size', 1, 'px'),
  /**
   * @label inverse tether box shadow v offset width when the list is above the target element
   * @editor width
   */
  inverseTetherBoxshadowVOffsetWidthAbove: value('size', 1, 'px'),
  /**
   * @label inverse tether box shadow blur width
   * @editor width
   */
  inverseTetherBoxshadowBlurWidth: value('size', 4, 'px'),
  /**
   * @label inverse tether box shadow spread width
   * @editor width
   */
  inverseTetherBoxshadowSpreadWidth: value('size', 1, 'px'),
  /**
   * @label inverse tether box shadow color
   * @editor width
   */
  inverseTetherBoxshadowColor: value('color', 'rgba(0, 0, 0, 0.1)'),
  /**
   * @label Dropdown border color (hover)
   * @editor color
   */
  borderColorHover: copy(theme.palettePrimaryStrokeLine),
  /**
   * @label Dropdown border color (focus)
   * @editor color
   */
  borderColorFocus: copy(theme.palettePrimaryStrokeLine),
  /**
   * @label Dropdown border radius
   * @editor borderRadius
   */
  borderRadius: value('size', 0, 'px'),
  outerBorderColor: copy(theme.palettePrimaryBorder),
  outerBorderRadius: value('size', 2, 'px'),
  outerBorderSize: value('size', 1, 'px'),
  /**
   * @label Dropdown background hover color
   * @editor color
   */
  hoverColor: copy(theme.paletteBackgroundTransparent),
  /**
   * @label Font family
   * @editor font
   */
  fontFamily: copy(theme.fontFamily),
  /**
   * @label Font size small
   * @editor font
   */
  fontSizeSmall: copy(theme.fontSizeSmall),
  /**
   * @label Font size normal
   * @editor font
   */
  fontSizeMedium: copy(theme.fontSizeMedium),
  /**
   * @label Font size large
   * @editor font
   */
  fontSizeLarge: copy(theme.fontSizeLarge),
  /**
   * @label Dropdown button height (small)
   * @editor height
   */
  buttonHeightSmall: copy(theme.heightSmall),
  /**
   * @label Dropdown button height (medium)
   * @editor height
   */
  buttonHeightMedium: copy(theme.heightMedium),
  /**
   * @label Dropdown button height (large)
   * @editor height
   */
  buttonHeightLarge: copy(theme.heightLarge),
  /**
   * @label Dropdown button height (large)
   * @editor height
   */
  buttonHeightNative: value('size', 44),
  /**
   * @label Dropdown list item height (small)
   * @editor height
   */
  listItemHeightSmall: copy(theme.heightSmall),
  /**
   * @label Dropdown list item height (medium)
   * @editor height
   */
  listItemHeightMedium: copy(theme.heightMedium),
  /**
   * @label Dropdown list item height (large)
   * @editor height
   */
  listItemHeightLarge: copy(theme.heightLarge),
  /**
   * @label Option bottom border color
   * @editor padding
   */
  itemBorderBottomColor: value('color', 'transparent'),
  /**
   * @label Option bottom border size
   * @editor width
   */
  itemBorderBottomSize: value('size', 0, 'px'),
  /**
   * @label Option container opacity
   * @editor opacity
   */
  optionContainerOpacity: value('opacity', 0.99),
  /**
   * @label Option group root background
   * @editor color
   */
  optionGroupRootBackground: copy(theme.palettePrimaryBackground),
  /**
   * @label Option group parent item font weight
   * @editor font
   */
  groupFontWeight: value('size', 'normal'),
  /**
   * @label Option group items padding left
   * @editor padding
   */
  groupPaddingLeft: value('size', 14, 'px'),
  /**
   * @label Dropdown Inverse Font Color
   * @editor color
   */
  inverseColor: copy(theme.palettePrimaryInverseTitleText),
  /**
   * @label Dropdown Inverse Placeholder Color
   * @editor color
   */
  inversePlaceHolderColor: copy(theme.palettePrimaryInverseDefaultText),
  /**
   * @label Dropdown Inverse Border Color
   * @editor color
   */
  inverseBorderColor: copy(theme.palettePrimaryInverseBorder),
  /**
   * @label Dropdown Inverse Border Color (hover)
   * @editor color
   */
  inverseBorderColorHover: copy(theme.palettePrimaryInverseBorder),
  /**
   * @label Dropdown Inverse Border Color (focus)
   * @editor color
   */
  inverseBorderColorFocus: copy(theme.palettePrimaryInverseBorder),
  /**
   * @label Dropdown Inverse Background Color
   * @editor color
   */
  inverseBackgroundColor: copy(theme.paletteBackgroundTransparent),
  /**
   * @label Dropdown Inverse background hover color
   * @editor color
   */
  inverseHoverColor: copy(theme.paletteBackgroundTransparent),
  /**
   * @label Dropdown Inverse Border Active Color
   * @editor color
   */
  inverseActiveBorderColor: copy(theme.palettePrimaryInverseActiveBackground),
  /**
   * @label Dropdown-Options Inverse Background
   * @editor color
   */
  inverseOptionsBackground: copy(theme.palettePrimaryInverseLightBackground),
  /**
   * @label Dropdown-Options Inverse Font Color
   * @editor color
   */
  inverseOptionsColor: copy(theme.palettePrimaryInverseDefaultText),
  /**
   * @label Dropdown-Options Inverse Group Font Color
   * @editor color
   */
  inverseGroupOptionsColor: copy(theme.palettePrimaryInverseDefaultText),
  /**
   * @label Dropdown-Options Inverse Active Background
   * @editor color
   */
  /* prettier-ignore */
  inverseOptionsActiveBackground: copy(theme.palettePrimaryInverseBrightBackground),
  /**
   * @label Dropdown-Options Inverse Selected Font Color
   * @editor color
   */
  inverseOptionSelectedColor: copy(theme.palettePrimaryInverseMainBackground),
  /**
   * @label Dropdown-Options Inverse Hover Color
   * @editor color
   */
  inverseOptionHoverColor: copy(theme.palettePrimaryInverseActiveBackground),
  /**
   * @label Dropdown-Options Item Inverse Border Color
   * @editor color
   */
  inverseItemBorderColor: copy(theme.palettePrimaryInverseBorder),
  /**
   * @label Dropdown-Options Inverse Disabled Font Color
   * @editor color
   */
  inverseDisabledTextColor: copy(theme.palettePrimaryInverseDisabledText),
});
